import { Pipe, PipeTransform, inject } from '@angular/core';
import { WordReplacementService } from '../services/word-replacement.service';

@Pipe({
  name: 'wordReplace',
  standalone: true,
  pure: false
})
export class WordReplacePipe implements PipeTransform {
  private wordService = inject(WordReplacementService);

  transform(value: string): string {
    return this.wordService.replaceWordsInSentence(value);
  }
}
